/*
  ============================================================
  AKCE 11.11 – skript pro vzhled (jeden soubor, jedna sada posluchačů)
  ------------------------------------------------------------
  Co tu je:
    1. odpočet          – jeden časovač na stránku (1 s), pauza na skryté
                          kartě, po konci se zastaví
    2. schované „11“    – umístění na fotku/sekci a bublina po ťuknutí
    3. hláška k Pokladně – „11 jídel zdarma je ve vašem košíku“ v košíku
    4. stránka dárku    – ukazatel „ještě X Kč do dárku“ podle košíku
                          a lepivé tlačítko dole
    5. značka dárku     – klik na kroužek s dárkem na ose lišty ukáže bublinu
                          (text vykresluje server podle košíku)
    6. barva okraje     – <meta name="theme-color"> v barvě hlavičky (jen mobil)

  Čas a stav akce řeší window.ZZAkce (snippets/zenzena-akce-head.liquid).
  Tenhle soubor jen zobrazuje, o dárku a prazích nerozhoduje ani nic
  nepřidává do košíku (to je assets/zenzena-loyalty.js).

  Pruh uprostřed stránek si přesouvá vlastní malý skript přímo v sekci
  (sections/zenzena-akce-pruh.liquid), aby běžel dřív než tenhle soubor.

  Save as: assets/zenzena-akce.js
  ============================================================
*/
(function () {
  'use strict';

  var doc = document;
  var html = doc.documentElement;
  var NBSP = ' ';

  function Z() { return window.ZZAkce || null; }
  function $(s, r) { return (r || doc).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function bezi() { var z = Z(); return !z || z.stav === 'bezi'; }
  function reduced() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function money(halere) {
    var kc = Math.ceil(halere / 100);
    return String(kc).replace(/\B(?=(\d{3})+(?!\d))/g, NBSP) + NBSP + 'Kč';
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function sklon(n, jedna, dva, pet) { return n === 1 ? jedna : (n >= 2 && n <= 4 ? dva : pet); }

  /* ============================================================
     1. ODPOČET
     ============================================================ */
  var cdTimer = null;
  var cdMinuta = -1;

  function zbyvaMs() {
    var z = Z();
    if (z) return z.stav === 'bezi' ? z.zbyva() : 0;
    var konec = parseInt(html.getAttribute('data-zz-akce-konec'), 10);
    return isFinite(konec) ? Math.max(0, konec - Date.now()) : 0;
  }

  function tick() {
    var cds = $$('[data-zz-akce-cd]');
    var s = Math.floor(zbyvaMs() / 1000);
    var v = {
      d: pad(Math.floor(s / 86400)),
      h: pad(Math.floor((s % 86400) / 3600)),
      m: pad(Math.floor((s % 3600) / 60)),
      s: pad(s % 60)
    };
    var minuta = Math.floor(s / 60);
    var nova = minuta !== cdMinuta;
    cdMinuta = minuta;
    cds.forEach(function (el) {
      $$('[data-u]', el).forEach(function (b) {
        var t = v[b.getAttribute('data-u')];
        if (b.textContent !== t) b.textContent = t;
      });
      // Čtečka dostává větu jednou za minutu, ne každou sekundu.
      if (nova) {
        var sr = $('[data-zz-akce-cd-sr]', el);
        if (sr) {
          var d = Math.floor(s / 86400);
          var h = Math.floor((s % 86400) / 3600);
          var m = Math.floor((s % 3600) / 60);
          sr.textContent = 'Do konce akce zbývá ' + d + ' ' + sklon(d, 'den', 'dny', 'dní') + ', ' +
            h + ' ' + sklon(h, 'hodina', 'hodiny', 'hodin') + ' a ' +
            m + ' ' + sklon(m, 'minuta', 'minuty', 'minut') + '.';
        }
      }
    });
    if (s <= 0) stopCd();
  }
  function stopCd() {
    if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }
  }
  function startCd() {
    if (cdTimer || doc.hidden || !bezi()) return;
    tick();
    cdTimer = setInterval(tick, 1000);
  }

  doc.addEventListener('visibilitychange', function () {
    if (doc.hidden) stopCd();
    else if (bezi()) startCd();
  });
  if (Z()) {
    Z().onChange(function (novy) {
      if (novy === 'bezi') startCd();
      else { tick(); stopCd(); }
    });
  }
  if (bezi()) startCd();

  /* ============================================================
     2. SCHOVANÉ „11“
     ============================================================ */
  // Mimo akci se s „11“ nic neděje: nepřesouvá se, hostiteli se nenastavuje
  // position a nevěší se posluchači. Inicializace proběhne jednou, buď hned
  // (akce běží), nebo při přechodu na „bezi“ (ZZAkce.onChange).
  var eggHotovo = false;
  function eggAzAkceBezi() {
    if (eggHotovo) return;
    var z = Z();
    if (!z || z.stav === 'bezi') { eggHotovo = true; initEgg(); return; }
    var odhlas = z.onChange(function (novy) {
      if (novy === 'bezi' && !eggHotovo) { eggHotovo = true; odhlas(); initEgg(); }
    });
  }

  function initEgg() {
    var wrap = doc.getElementById('shopify-section-zenzena-akce-egg');
    var egg = wrap && $('[data-zz-akce-egg]', wrap);
    if (!egg) return;

    var btn = $('.zz-egg__btn', egg);
    var panel = $('.zz-egg__panel', egg);
    var host = null;
    var otevreno = false;
    var SIZE = 56;
    var OKRAJ = 14;

    function body(cls) { return doc.body.classList.contains(cls); }

    // Kam se „11“ posadí: { host, kotva, roh }. host je prvek bez ořezu, ke
    // kterému se drží (bublina smí přes okraj fotky), kotva je fotka, na jejíž
    // roh to sedí.
    function cil() {
      var main = $('#main');
      if (!main) return null;
      if (body('template-index')) {
        var sekce = $$('.shopify-section', main).filter(function (s) {
          return s.parentNode === main && s.id.indexOf('zenzena-akce') === -1 && s.offsetHeight > 40;
        });
        var h = sekce[2] || sekce[sekce.length - 1];
        if (!h) return null;
        var img = $$('img', h).filter(function (i) { return i.offsetWidth > 140 && i.offsetHeight > 140; })[0];
        return { host: h, kotva: img || h, roh: 'br' };
      }
      if (body('template-product')) {
        var m = $('[id$="__main"]', main) || $('.shopify-section--main-product', main);
        if (!m) return null;
        var foto = $('.product-gallery__media', m) || $('product-gallery', m);
        return { host: m, kotva: foto || m, roh: 'bl' };
      }
      if (body('template-collection')) {
        var k = $('[id$="__main"]', main);
        if (!k) return null;
        // Fotka bez štítků v rohu (kolagen má přes celý horní okraj štítek
        // „Shaker + odměrka zdarma“), od 4. produktu dál.
        var karty = $$('.product-card__figure', k);
        var karta = karty.slice(3).filter(function (f) { return !f.querySelector('.badge-list'); })[0] || karty[3] || karty[karty.length - 1];
        return { host: k, kotva: karta || k, roh: 'tr' };
      }
      return null;
    }

    function umisti() {
      var c = cil();
      if (!c) return;
      if (c.host !== host) {
        host = c.host;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        host.appendChild(egg);
      }
      var hr = host.getBoundingClientRect();
      var ar = c.kotva.getBoundingClientRect();
      if (!ar.width) return;
      var left, top;
      if (c.roh === 'bl') { left = ar.left - hr.left + OKRAJ; top = ar.bottom - hr.top - SIZE - OKRAJ; }
      else if (c.roh === 'tr') { left = ar.right - hr.left - SIZE - OKRAJ; top = ar.top - hr.top + OKRAJ; }
      else { left = ar.right - hr.left - SIZE - OKRAJ; top = ar.bottom - hr.top - SIZE - OKRAJ; }
      egg.style.left = Math.max(4, Math.round(left)) + 'px';
      egg.style.top = Math.max(4, Math.round(top)) + 'px';
      egg.setAttribute('data-placed', '');
    }

    var cekani = null;
    function odlozene() {
      if (cekani) return;
      cekani = requestAnimationFrame(function () { cekani = null; umisti(); });
    }

    // Strana a svislý směr bubliny podle místa. Panel se vždy sevře do okna
    // [8, šířka okna − šířka panelu − 8], takže nepřeteče ani na 360 px a
    // nerozšíří stránku (křížek zavření zůstane na obrazovce).
    function nastavSmer() {
      var MEZ = 8;
      var r = btn.getBoundingClientRect();
      var vw = doc.documentElement.clientWidth || window.innerWidth;
      var sirka = Math.min(300, vw - 32);
      panel.style.width = sirka + 'px';
      var vejdeVlevo = r.right - sirka >= MEZ;           // panel končí u pravého okraje tlačítka
      var vejdeVpravo = r.left + sirka <= vw - MEZ;      // panel začíná u levého okraje tlačítka
      var doprava;                                       // true = panel roste doleva (tlačítko vpravo)
      if (vejdeVlevo && vejdeVpravo) doprava = (r.left + r.width / 2) > vw / 2;
      else if (vejdeVlevo) doprava = true;
      else if (vejdeVpravo) doprava = false;
      else doprava = (r.left + r.width / 2) > vw / 2;
      var levy = doprava ? r.right - sirka : r.left;
      levy = Math.max(MEZ, Math.min(levy, vw - sirka - MEZ));
      panel.style.left = Math.round(levy - r.left) + 'px';
      panel.style.right = 'auto';
      var dolu = (window.innerHeight - r.bottom) > panel.offsetHeight + 24 && r.top < window.innerHeight * 0.55;
      egg.classList.toggle('zz-egg--dolu', dolu);
      egg.classList.toggle('zz-egg--vlevo', !doprava);
    }
    function otevri() {
      nastavSmer();
      otevreno = true;
      egg.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function zavri(vratFokus) {
      if (!otevreno) return;
      otevreno = false;
      egg.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (vratFokus) btn.focus();
    }

    btn.addEventListener('click', function () { if (otevreno) zavri(false); else otevri(); });
    $('.zz-egg__x', egg).addEventListener('click', function () { zavri(true); });
    doc.addEventListener('click', function (e) { if (otevreno && !egg.contains(e.target)) zavri(false); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') zavri(true); });

    umisti();
    window.addEventListener('load', umisti);
    window.addEventListener('resize', odlozene);
    // Fotky a písma se dotahují po načtení a posouvají rozvržení.
    doc.addEventListener('load', odlozene, true);
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(odlozene);
      var main = $('#main');
      if (main) ro.observe(main);
    }
  }

  /* ============================================================
     3. HLÁŠKA U TLAČÍTKA POKLADNA
     Správce dárků (zenzena-loyalty.js) po přidání a odebrání dárku akce
     pošle obecnou hlášku (toast:show). Tady se zachytí dřív, než ji vezme
     spodní lišta motivu, a v košíku se ukáže vlastní hláška nad Pokladnou.
     Mimo košík (a pro cizí hlášky) projde beze změny.
     ============================================================ */
  var toastEl = null;
  var toastCas = null;
  var K_TOAST = 'zz_akce_toast';

  function jeStrankaKosiku() {
    return doc.body.classList.contains('template-cart');
  }
  function konfigBaru() { return $('[data-zz-config]'); }

  function tonicDarek() {
    return '<svg class="zz-akce-ikona" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3.5" y="9" width="17" height="11" rx="2"/><path d="M12 9v11M3.5 13.5h17"/><path d="M12 9C9.2 9 7.6 7.6 8.1 6.1 8.7 4.5 11 5.2 12 9zM12 9c2.8 0 4.4-1.4 3.9-2.9C15.3 4.5 13 5.2 12 9z"/></svg>';
  }
  function tonicKriz() {
    return '<svg class="zz-akce-ikona" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  }

  // Kam hláška patří: nad patičku draweru (otevřený), nebo pevně dole na /cart.
  function toastMisto() {
    if (jeStrankaKosiku()) return { rodic: doc.body, pevna: true };
    var drawer = $('cart-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return null; // zásuvka je zavřená
    var paticka = $('[slot="footer"]', drawer);
    if (!paticka || !paticka.offsetHeight) return null;
    var r = paticka.getBoundingClientRect();
    if (r.right <= 0 || r.left >= window.innerWidth) return null;
    return { rodic: paticka, pevna: false };
  }

  function ukazHlasku(text, typ, mistoVynuceno) {
    var misto = mistoVynuceno || toastMisto();
    if (!misto) return false;
    if (toastEl && toastEl.parentNode) toastEl.parentNode.removeChild(toastEl);
    toastEl = doc.createElement('div');
    toastEl.className = 'zz-akce-toast' + (misto.pevna ? ' zz-akce-toast--pevna' : '') + (typ === 'pod' ? ' zz-akce-toast--pod' : '');
    toastEl.setAttribute('role', 'status');
    toastEl.innerHTML = '<span class="zz-akce-toast__i">' + (typ === 'pod' ? tonicKriz() : tonicDarek()) + '</span><span></span>';
    toastEl.lastChild.textContent = text;
    if (!misto.pevna && getComputedStyle(misto.rodic).position === 'static') misto.rodic.style.position = 'relative';
    misto.rodic.appendChild(toastEl);
    void toastEl.offsetWidth;
    toastEl.classList.add('is-on');
    clearTimeout(toastCas);
    var el = toastEl;
    toastCas = setTimeout(function () {
      el.classList.remove('is-on');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 450);
    }, 5000);
    return true;
  }

  function textPridano() { return '11 proteinových jídel zdarma je ve vašem košíku'; }
  function textPod() {
    var c = konfigBaru();
    var lista = $('.zz-akce-lista[data-zz-akce-zbyva]');
    var prah = c ? c.getAttribute('data-akce-prah-label') : '';
    var t = 'Jídla zdarma zmizela z košíku, ten klesl pod ' + (prah ? prah.replace(/ /g, NBSP) : 'práh') + '.';
    if (lista && lista.getAttribute('data-zz-akce-stupen') === 'darek') {
      var z = parseInt(lista.getAttribute('data-zz-akce-zbyva'), 10);
      if (isFinite(z) && z > 0) t += ' Ještě ' + money(z) + ' a vrátí se.';
    }
    return t.replace(/ (Kč)/g, NBSP + '$1');
  }

  function zachytHlasku(e) {
    var c = konfigBaru();
    var label = c && c.getAttribute('data-akce-label');
    var msg = e && e.detail && e.detail.message;
    if (!label || typeof msg !== 'string' || msg.indexOf(label) !== 0) return;
    var typ = null;
    if (/je v košíku/.test(msg)) typ = 'pridano';
    else if (/odebrali jsme/.test(msg) && Z() && Z().stav === 'bezi') typ = 'pod';
    if (!typ) return;
    var text = typ === 'pridano' ? textPridano() : textPod();
    if (jeStrankaKosiku()) {
      // Na /cart se po změně stránka znovu načte, hláška se ukáže až potom.
      try { sessionStorage.setItem(K_TOAST, JSON.stringify({ typ: typ, text: text, cas: Date.now() })); } catch (err) { /* soukromý režim */ }
      e.stopImmediatePropagation();
      return;
    }
    // V zásuvce až po překreslení (cart:change přijde po této události).
    if (toastMisto()) {
      e.stopImmediatePropagation();
      cekaHlaska = { typ: typ, text: text, cas: Date.now() };
      setTimeout(dorucHlasku, 700);
    }
  }
  var cekaHlaska = null;
  function dorucHlasku() {
    if (!cekaHlaska) return;
    var h = cekaHlaska;
    cekaHlaska = null;
    if (Date.now() - h.cas > 4000) return;
    if (!ukazHlasku(h.text, h.typ === 'pod' ? 'pod' : 'ano')) {
      // Zásuvka se mezitím zavřela: obecná hláška motivu.
      try { doc.dispatchEvent(new CustomEvent('toast:show', { detail: { message: h.text } })); } catch (err) { /* nic */ }
    }
  }
  window.addEventListener('toast:show', zachytHlasku, true);
  doc.addEventListener('cart:change', function () { if (cekaHlaska) setTimeout(dorucHlasku, 250); });

  function hlaskaPoNacteni() {
    if (!jeStrankaKosiku()) return;
    var raw = null;
    try { raw = sessionStorage.getItem(K_TOAST); sessionStorage.removeItem(K_TOAST); } catch (err) { raw = null; }
    if (!raw) return;
    try {
      var h = JSON.parse(raw);
      if (h && Date.now() - h.cas < 8000) ukazHlasku(h.text, h.typ === 'pod' ? 'pod' : 'ano');
    } catch (err) { /* poškozený záznam */ }
  }

  /* ============================================================
     4. STRÁNKA DÁRKU: ukazatel podle košíku + lepivé tlačítko
     ============================================================ */
  function initDarek() {
    var goal = $('[data-zz-akce-goal]');
    if (!goal) return;
    var prah = parseInt(goal.getAttribute('data-prah'), 10);
    var t = $('[data-goal-t]', goal);
    var n = $('[data-goal-n]', goal);
    var bar = $('[data-goal-bar]', goal);
    var fill = $('[data-goal-fill]', goal);
    var cta = $('[data-goal-cta]', goal);
    var sticky = $('[data-zz-akce-sticky]');
    var stickyCta = sticky && $('[data-sticky-cta]', sticky);

    function nastavTlacitko(a, label, href) {
      if (!a) return;
      var obsah = $('.button__content', a) || a;
      if (obsah.textContent !== label) obsah.textContent = label;
      if (href) a.setAttribute('href', href);
    }

    function nastav() {
      var c = konfigBaru();
      if (!c || !isFinite(prah)) return;
      var sub = parseInt(c.getAttribute('data-subtotal'), 10);
      var poc = parseInt(c.getAttribute('data-item-count'), 10);
      if (!isFinite(sub)) return;
      // „Máte v košíku“ jen když dárek v košíku opravdu je (počítá server, lišta
      // ho nese v data-zz-akce-ks). Nad prahem bez dárku (správce ho právě
      // přidává, nebo ho drží pojistka) je stav „pridava“. Bez lišty se jde
      // podle mezisoučtu.
      var lista = $('.zz-akce-lista[data-zz-akce-ks]');
      var ks = lista ? parseInt(lista.getAttribute('data-zz-akce-ks'), 10) : NaN;
      var mame = isFinite(ks) ? ks > 0 : sub >= prah;
      var stav = poc === 0 ? 'prazdny' : (sub >= prah ? (mame ? 'ok' : 'pridava') : 'chybi');
      var text = goal.getAttribute('data-t-' + stav) || '';
      text = text.replace('{zbyva}', money(Math.max(0, prah - sub)));
      var pct = Math.max(0, Math.min(100, Math.round((sub / prah) * 1000) / 10));
      goal.setAttribute('data-stav', stav);
      if (t) {
        t.textContent = '';
        if (stav === 'ok') {
          var ok = doc.createElement('span');
          ok.className = 'zzad__ok';
          ok.setAttribute('aria-hidden', 'true');
          ok.textContent = '\u2713';
          t.appendChild(ok);
        }
        t.appendChild(doc.createTextNode(text));
      }
      if (n) n.hidden = stav === 'prazdny';
      if (fill) fill.style.width = pct + '%';
      if (bar) { bar.setAttribute('aria-valuenow', String(Math.round(Math.min(sub, prah) / 100))); }
      var label = goal.getAttribute('data-cta-' + stav) || '';
      var href = goal.getAttribute('data-href-' + stav) || '';
      nastavTlacitko(cta, label, href);
      nastavTlacitko(stickyCta, label, href);
    }
    nastav();

    var lista = $('zenzena-upsell-bar');
    if (lista && 'MutationObserver' in window) {
      new MutationObserver(nastav).observe(lista, { childList: true });
    }
    doc.addEventListener('cart:change', function () { setTimeout(nastav, 400); });

    // Lepivé tlačítko je vidět, dokud tlačítko v kartě není na obrazovce.
    if (sticky) {
      var set = function (pryc) {
        html.setAttribute('data-zz-atc', pryc ? 'away' : 'near');
        sticky.inert = !pryc;
      };
      set(true);
      if ('IntersectionObserver' in window && cta) {
        new IntersectionObserver(function (zaznamy) {
          set(!zaznamy[0].isIntersecting);
        }, { rootMargin: '-24px 0px -96px 0px', threshold: 0 }).observe(cta);
      }
    }
  }

  /* ============================================================
     5. ZNAČKA DÁRKU NA OSE LIŠTY: bublina
     Značka je <button data-zz-akce-znacka> uvnitř karty, která je celá
     odkaz na stránku dárku (a.zz-akce-odkaz::after). Tlačítko leží nad
     odkazem, takže klik na něj nenaviguje. Text bubliny (.zz-akce-bublina,
     id v aria-controls) píše server podle košíku, tady se jen ukazuje.

     Lišta se po každé změně košíku překresluje (replaceChildren), proto
     posluchače visí na dokumentu a stav se nedrží v uzlech. Překreslení
     bublinu zavře, což je v pořádku: text už by nemusel platit.
     Zavírá ji klik jinam, Esc a posun stránky o víc než kousek; při změně
     šířky okna se jen přepočítá.
     ============================================================ */
  var zOtevrena = null; // { btn, bub }
  var zScrollY = 0;

  function zavriZnacku(vratFokus) {
    if (!zOtevrena) return;
    var o = zOtevrena;
    zOtevrena = null;
    if (o.bub) o.bub.hidden = true;
    if (o.btn) {
      o.btn.setAttribute('aria-expanded', 'false');
      if (vratFokus && o.btn.isConnected) o.btn.focus();
    }
  }

  // Bublina se sevře do okna: od okraje nejméně 8 px (360 i 375 px), špička
  // míří na střed značky.
  function umistiBublinu(btn, bub) {
    var MEZ = 8;
    var vw = doc.documentElement.clientWidth || window.innerWidth;
    var rodic = bub.offsetParent;
    if (!rodic) return;
    var rp = rodic.getBoundingClientRect();
    var rb = btn.getBoundingClientRect();
    var sirka = bub.offsetWidth;
    var stred = rb.left + rb.width / 2;
    var levy = Math.max(MEZ, Math.min(stred - sirka / 2, vw - MEZ - sirka));
    bub.style.left = Math.round(levy - rp.left) + 'px';
    var spicka = Math.max(14, Math.min(stred - levy, sirka - 14));
    bub.style.setProperty('--zz-akce-spicka', Math.round(spicka) + 'px');
  }

  function otevriZnacku(btn) {
    var bub = doc.getElementById(btn.getAttribute('aria-controls') || '');
    if (!bub) return;
    zavriZnacku(false);
    bub.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    umistiBublinu(btn, bub);
    zOtevrena = { btn: btn, bub: bub };
    zScrollY = window.pageYOffset || 0;
    zSirka = doc.documentElement.clientWidth || window.innerWidth;
  }

  doc.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-zz-akce-znacka]');
    if (btn) {
      e.preventDefault();
      if (zOtevrena && zOtevrena.btn === btn) zavriZnacku(false);
      else otevriZnacku(btn);
      return;
    }
    if (zOtevrena && !(zOtevrena.bub && zOtevrena.bub.contains(e.target))) zavriZnacku(false);
  });
  doc.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && zOtevrena) zavriZnacku(true);
  });
  // Mobilní prohlížeč mění výšku okna i při skrývání adresního řádku, proto
  // se reaguje jen na změnu šířky (otočení telefonu): bublina se přepočítá.
  var zSirka = 0;
  window.addEventListener('resize', function () {
    if (!zOtevrena) return;
    var vw = doc.documentElement.clientWidth || window.innerWidth;
    if (vw === zSirka) return;
    zSirka = vw;
    if (zOtevrena.btn.isConnected) umistiBublinu(zOtevrena.btn, zOtevrena.bub);
    else zavriZnacku(false);
  });
  window.addEventListener('scroll', function () {
    if (zOtevrena && Math.abs((window.pageYOffset || 0) - zScrollY) > 48) zavriZnacku(false);
  }, { passive: true });
  // lišta se překreslila: tlačítko z DOMu zmizelo
  doc.addEventListener('cart:change', function () {
    if (zOtevrena && !zOtevrena.btn.isConnected) zOtevrena = null;
  });

  /* ============================================================
     6. BARVA HORNÍHO OKRAJE NA MOBILU
     Hlavička je v akci na mobilu plná barva --zz-akce-hlavicka
     (assets/zenzena-akce.css, „Pozadí stránky“). Stejnou barvu dostane
     <meta name="theme-color"> jen pro úzká okna, ať stavový řádek
     a horní okraj prohlížeče na telefonu nejsou jiné než hlavička.
     Mimo akci se meta odstraní (stránka je pak jako dřív).
     ============================================================ */
  function nastavBarvuOkraje() {
    var meta = $('meta[name="theme-color"][data-zz-akce]');
    if (!bezi()) { if (meta && meta.parentNode) meta.parentNode.removeChild(meta); return; }
    var barva = '';
    try { barva = getComputedStyle(html).getPropertyValue('--zz-akce-hlavicka').trim(); } catch (e) { barva = ''; }
    if (!barva) barva = '#DED4E8';
    if (!meta) {
      meta = doc.createElement('meta');
      meta.setAttribute('name', 'theme-color');
      meta.setAttribute('media', 'not all and (min-width: 750px)');
      meta.setAttribute('data-zz-akce', '');
      doc.head.appendChild(meta);
    }
    meta.setAttribute('content', barva);
  }
  if (Z()) Z().onChange(nastavBarvuOkraje);

  function start() {
    eggAzAkceBezi();
    nastavBarvuOkraje();
    initDarek();
    hlaskaPoNacteni();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
